import InlineMessage from './InlineMessage'

export default InlineMessage
